import { render } from "./ModalAttachmentsComponent.vue?vue&type=template&id=373a3620"
import script from "./ModalAttachmentsComponent.vue?vue&type=script&lang=js"
export * from "./ModalAttachmentsComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__